import { createContext, useContext } from 'react';

const ImportHubAccessContext = createContext(false);

export const ImportHubAccessProvider = ImportHubAccessContext.Provider;

export const useImportHubReadOnly = (): boolean =>
  useContext(ImportHubAccessContext);
